module.exports = {
	"id": "FO",
	"name": "Faroe Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.037499,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005357,
			"22": 0.016071,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.005357,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.005357,
			"32": null,
			"33": 0.074998,
			"34": 0.021428,
			"35": null,
			"36": 0.016071,
			"37": null,
			"38": 0.05357,
			"39": null,
			"40": 0.010714,
			"41": null,
			"42": null,
			"43": 0.021428,
			"44": 0.037499,
			"45": null,
			"46": null,
			"47": 0.010714,
			"48": 0.021428,
			"49": 1.564244,
			"50": 0.016071,
			"51": 0.080355,
			"52": 0.166067,
			"53": 16.274566,
			"54": 4.757016,
			"55": 0.048213,
			"56": 0.010714,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016071,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.010714,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.005357,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.048213,
			"39": 0.016071,
			"40": 0.010714,
			"41": null,
			"42": null,
			"43": 0.021428,
			"44": 0.032142,
			"45": 0.541057,
			"46": 0.016071,
			"47": 0.112497,
			"48": 0.235708,
			"49": 4.799872,
			"50": 0.005357,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.032142,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.016071,
			"37": 0.016071,
			"38": null,
			"39": null,
			"40": 0.091069,
			"41": 0.010714,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.010714
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.016071,
			"6": 0.010714,
			"7": 0.032142,
			"8": 0.21428,
			"9": 0.198209,
			"10": 1.542816,
			"3.1": null,
			"3.2": null,
			"5.1": 0.101783,
			"6.1": 0.257136,
			"7.1": 0.016071,
			"9.1": 1.537459
		},
		"ios_saf": {
			"8": 0,
			"10": 20.2910040624,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.546819080246,
			"8.1-8.4": 1.01022508045,
			"9.0-9.2": 0.481942240216,
			"9.3": 7.35270853664
		},
		"android": {
			"3": 0,
			"4": 0.00907004651163,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00113375581395,
			"4.1": 0.0327169534884,
			"4.2-4.3": 0.0817923837209,
			"4.4": 0.187555604651,
			"4.4.3-4.4.4": 0.189175255814
		},
		"ie": {
			"6": null,
			"7": 0.021428,
			"8": 0.187495,
			"9": 0.423203,
			"10": 0.16071,
			"11": 13.488926,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00480290342731,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000133413984092
		},
		"edge": {
			"12": 0.074998,
			"13": 1.489246,
			"14": 3.615975
		},
		"ie_mob": {
			"10": 0.242613098592,
			"11": 0.987781901408
		},
		"bb": {
			"7": 0.00580375,
			"10": null
		},
		"samsung": {
			"0": 5.687675
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0.0647086825886
		},
		"and_chr": {
			"0": 9.35026
		},
		"and_ff": {
			"0": 0.027858
		}
	},
	"total": 99.24723175
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FO.json
 ** module id = 522
 ** module chunks = 0
 **/